import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  IconButton,
  Stack,
  Divider,
  Grid,
  Fade,
} from '@mui/material';
import {
  LinkedIn,
  Email,
  KeyboardArrowUp,
  Terminal,
  LocationOn,
} from '@mui/icons-material';
import { useThemeMode } from '../contexts/ThemeContext';

const Footer = () => {
  const { darkMode } = useThemeMode();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setShowScrollTop(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };



  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        mt: 'auto',
        background: darkMode
          ? 'linear-gradient(135deg, rgba(10,10,10,0.95) 0%, rgba(26,26,26,0.95) 50%, rgba(10,10,10,0.95) 100%)'
          : 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.95) 50%, rgba(241,245,249,0.95) 100%)',
        backdropFilter: 'blur(24px)',
        borderTop: darkMode
          ? '1px solid rgba(255, 255, 255, 0.1)'
          : '1px solid rgba(0, 0, 0, 0.08)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: darkMode
            ? 'linear-gradient(90deg, rgba(25, 118, 210, 0.05) 0%, rgba(220, 0, 78, 0.05) 100%)'
            : 'linear-gradient(90deg, rgba(25, 118, 210, 0.03) 0%, rgba(220, 0, 78, 0.03) 100%)',
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>


        {/* Bottom Section */}
        <Divider
          sx={{
            borderColor: darkMode
              ? 'rgba(255, 255, 255, 0.1)'
              : 'rgba(0, 0, 0, 0.08)',
            mb: 4,
          }}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 3,
            gap: 2,
          }}
        >
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontWeight: 500,
                mb: 0.5,
              }}
            >
              © {new Date().getFullYear()} Yogesh More. All rights reserved.
            </Typography>

          </Box>


        </Box>
      </Container>

      {/* Scroll to Top Button */}
      <Fade in={showScrollTop}>
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: { xs: 20, sm: 20 },
            right: { xs: 20, sm: 30 },
            width: 50,
            height: 50,
            background: darkMode
              ? '2px solid rgba(116, 15, 15, 0.2)'
              : '2px solid rgba(0, 0, 0, 0.1)',
            color: darkMode
              ? '2px solid rgba(255, 255, 255, 0.2)'
              : '2px solid rgba(0, 0, 0, 0.1)',
            border: darkMode
              ? '2px solid rgba(255, 255, 255, 0.2)'
              : '2px solid rgba(0, 0, 0, 0.1)',
            boxShadow: darkMode
              ? '0 8px 25px rgba(0, 0, 0, 0.3)'
              : '0 8px 25px rgba(0, 0, 0, 0.15)',
            backdropFilter: 'blur(10px)',
            zIndex: 1000,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              transform: 'translateY(-3px) scale(1.1)',
              boxShadow: darkMode
                ? '0 12px 35px rgba(0, 0, 0, 0.4)'
                : '0 12px 35px rgba(0, 0, 0, 0.2)',
            },
          }}
        >
          <KeyboardArrowUp sx={{ fontSize: 24 }} />
        </IconButton>
      </Fade>
    </Box>
  );
};

export default Footer;